module.exports = __webpack_public_path__ + "img/title.159cd828.png";